import { enumToStaticValue } from '@/utils'
import { MoneyMovementType } from '@/modules/money/movement/type/moneyMovementType'

export default enumToStaticValue(MoneyMovementType, 'money-movement-type')
